import BControlPro from "../../../../components/BControlPro";
import BColor from "../../BColor";

const { PanelBody, PanelRow, Button, TextControl, FormToggle, SelectControl, ButtonGroup, __experimentalUnitControl: UnitControl, ToggleControl } = wp.components;
const { __ } = wp.i18n;
import { __experimentalBoxControl as BoxControl } from "@wordpress/components";

const Popup = ({ attributes, updateFeatures, isPremium }) => {
  const { popupBtnStyle, features } = attributes;
  const { enabled, type, selector, hasBtn, btnText, align, btnStyle } = features.popup || {};
  const { color, backgroundColor, fontSize, padding } = btnStyle;

  const updatePopup = (value) => {
    const [property] = Object.keys(value);
    updateFeatures({ ...attributes.features.popup, [property]: value[property] }, "popup");
  };

  // const updatePopup = (value) => {
  //   const [property] = Object.keys(value);
  //   updatePopup({ ...btnStyle, [property]: value[property] });
  // };

  return (
    <PanelBody title={__("Popup", "h5vp")} initialOpen={false}>
      <BControlPro
        isPremium={isPremium}
        Component={ToggleControl}
        label={__("Enable Popup", "h5vp")}
        id="popup"
        checked={enabled}
        onChange={() => updatePopup({ enabled: !enabled })}
      />
      {enabled && (
        <>
          <SelectControl
            value={type}
            options={[
              { label: "poster", value: "poster" },
              { label: "Button", value: "button" },
            ]}
            onChange={(type) => {
              updatePopup({ type });
            }}
          />
          {type === "button" && (
            <PanelRow>
              <label className="label">{__("Use Exists Button", "h5vp")}</label>
              <FormToggle id="popupBtnExists" checked={hasBtn} onChange={() => updatePopup({ hasBtn: !hasBtn })} />
            </PanelRow>
          )}
          {type === "button" && hasBtn && (
            <>
              <PanelRow>
                <label className="label">{__("Button Class", "h5vp")}</label>
              </PanelRow>
              <TextControl value={selector} onChange={(selector) => updatePopup({ selector })} />
            </>
          )}
          {type === "button" && !hasBtn && (
            <PanelBody title="Button Style">
              <>
                <PanelRow>
                  <label className="label">{__("Color", "h5vp")}</label>
                  <BColor value={color} onChange={(color) => updatePopup({ btnStyle: { ...btnStyle, color } })} />
                </PanelRow>
                <PanelRow>
                  <label className="label">{__("Background Color", "h5vp")}</label>
                  <BColor value={backgroundColor} onChange={(backgroundColor) => updatePopup({ btnStyle: { ...btnStyle, backgroundColor } })} />
                </PanelRow>
                <PanelRow>
                  <label htmlFor="" className="label">
                    {__("Font Size", "h5vp")}
                  </label>
                  <UnitControl
                    onChange={(fontSize) => updatePopup({ btnStyle: { ...btnStyle, fontSize } })}
                    value={fontSize}
                    units={[
                      { label: "px", value: "px", default: 16 },
                      { label: "em", value: "1", default: 1 },
                      { label: "rem", value: "1.6", default: 1.6 },
                    ]}
                  />
                </PanelRow>
                <PanelRow>
                  <BoxControl label={__("Padding", "h5vp")} values={padding} onChange={(padding) => updatePopup({ btnStyle: { ...btnStyle, padding } })} />
                </PanelRow>
                <PanelRow>
                  <label htmlFor="" className="label">
                    {__("Button Align", "h5vp")}
                  </label>
                  <ButtonGroup>
                    <Button icon="editor-alignleft" onClick={() => updatePopup({ align: "left" })} variant={align === "left" ? "primary" : "secondary"}></Button>
                    <Button icon="editor-aligncenter" onClick={() => updatePopup({ align: "center" })} variant={align === "center" ? "primary" : "secondary"}></Button>
                    <Button icon="editor-alignright" onClick={() => updatePopup({ align: "right" })} variant={align === "right" ? "primary" : "secondary"}></Button>
                  </ButtonGroup>
                </PanelRow>
                <TextControl label={__("Button Text", "h5vp")} value={btnText} onChange={(btnText) => updatePopup({ btnText })} />
              </>
            </PanelBody>
          )}
        </>
      )}
    </PanelBody>
  );
};

export default Popup;
